import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";
import { waLink } from "@/lib/site";
import { MessageCircle } from "lucide-react";

export const FAQS = [
  {
    q: "Do you really come to my location?",
    a: "Yes. GoGoAuto Mobile Repair & Service is fully mobile — a licensed 310S master technician arrives at your driveway, workplace, or wherever your vehicle is parked, anywhere in Scarborough and the Greater Toronto Area. No towing, no waiting rooms. For larger jobs, off-site service and vehicle pick-up are also available.",
  },
  {
    q: "How much is the mobile call-out fee?",
    a: "The call-out fee is a flat $100, which covers travel and basic vehicle setup anywhere in our service area. Many services — like brake jobs, oil changes, and under-hood repairs — already include the call-out in the listed price, so the number you see is the number you pay.",
  },
  {
    q: "Which areas do you serve?",
    a: "We cover Scarborough, North York, Markham, Pickering, Ajax, Etobicoke, and Downtown Toronto. If you are just outside these areas, message us on WhatsApp — we can often still help or arrange vehicle pick-up.",
  },
  {
    q: "Can you fix a car that won't start?",
    a: "Absolutely — no-start and electrical diagnostics are our specialty. We perform circuit isolation, voltage-drop testing, parasitic draw checks, battery testing, and full-module computer scans right at your location, then explain exactly what's wrong before any repair begins.",
  },
  {
    q: "Do I need to buy the parts myself?",
    a: "No. We can source quality parts for your vehicle and include them in your quote, or we can install customer-supplied parts if you prefer. Either way, you approve the full price — parts and labour — before work starts.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes. Every vehicle is serviced by a licensed Ontario 310S Automotive Service Technician — the same credential held by senior dealership technicians — using OEM-grade diagnostic equipment.",
  },
  {
    q: "How do I book an appointment?",
    a: "Book online in under a minute using the form on this page — pick a service, choose a date and time window, and you'll get an instant confirmation email with a reference code. Prefer to talk first? Tap the WhatsApp button for a quick quote.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="relative bg-charcoal py-16 sm:py-24 lg:py-32 border-t border-white/5 noise-overlay">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <Eyebrow>Common Questions</Eyebrow>
        <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none">
          Before you <span className="text-ember">book</span>
        </h2>
        <p className="mt-4 text-mist text-base max-w-lg mx-auto">
          Straight answers about mobile auto repair in Scarborough &amp; the GTA.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-panel border border-white/10 rounded-sm px-6 data-[state=open]:border-ember/40 transition-colors"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-display font-bold uppercase tracking-wide text-lg sm:text-xl text-white hover:text-ember hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-mist text-sm leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>

      <Reveal delay={0.25} className="mt-10 text-center">
        <a
          data-testid="faq-whatsapp-btn"
          href={waLink("Hi GoGoAuto! I have a question that isn't in your FAQ.")}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 border border-[#25D366]/60 text-[#25D366] font-display font-bold uppercase tracking-wider px-7 py-3 rounded-sm hover:bg-[#25D366] hover:text-obsidian transition-all duration-200"
        >
          <MessageCircle className="w-5 h-5" /> Ask us on WhatsApp
        </a>
      </Reveal>
    </div>
  </section>
);
